'use client'

import * as React from 'react'

import IconDelta from '@/components/svgs/icon-delta.svg'
import { EVENTS } from '@/constant/siteConstants'

export default function TheMenuAlbumNav() {
  const [prevEvent] = React.useState(new CustomEvent(EVENTS.albumPrev))
  const [nextEvent] = React.useState(new CustomEvent(EVENTS.albumNext))
  return (
    <div className='sI:block absolute right-0 bottom-1/2 hidden h-auto w-[var(--menu-bar-width)] translate-y-1/4'>
      <button
        className='menu--button'
        aria-label='Previous photo'
        onClick={() => {
          window.dispatchEvent(prevEvent)
        }}
      >
        <IconDelta className='h-auto w-[40%]' />
      </button>
      <button
        className='menu--button border-b'
        aria-label='Next photo'
        onClick={() => {
          window.dispatchEvent(nextEvent)
        }}
      >
        <IconDelta className='h-auto w-[40%] rotate-180' />
      </button>
    </div>
  )
}
